// Routeur de l'application : connexion tant que la session n'est pas complète, puis coquille et écrans.

import type { ReactElement } from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { useSession } from './session';
import { Coquille } from './Coquille';
import { MessageErreur, Squelette } from '../composants/Etats';
import { PageConnexion } from '../modules/auth/Connexion';
import { Accueil } from '../modules/accueil/Accueil';
import { ListeInstallations } from '../modules/referentiel/Installations';
import { NouvelleInstallation } from '../modules/referentiel/NouvelleInstallation';
import { FicheInstallation } from '../modules/referentiel/InstallationFiche';
import { Doublons, FicheOrganisation, Flotte, ListeOrganisations } from '../modules/referentiel/Autres';
import { Catalogue } from '../modules/catalogue/Catalogue';
import { FicheDocument, ListeDocuments } from '../modules/documents/Documents';
import {
  AdministrationOrganisations,
  AdministrationParametres,
  AdministrationRoles,
  AdministrationUtilisateurs,
  FicheUtilisateur,
  JournalAudit,
  NouvelUtilisateur,
} from '../modules/administration/Administration';
import { PagePreferences } from '../modules/preferences/Preferences';
import { PageAPropos, PageRecherche } from '../modules/systeme/Systeme';
import { ROUTES_STOCKS } from '../modules/stocks/inscription';
import { inscription as inscriptionNotifications } from '../modules/notifications';
import { inscription as inscriptionMessagerie } from '../modules/messagerie';
import { inscription as inscriptionControle } from '../modules/controle';
import { inscription as inscriptionInspections } from '../modules/inspections';
import { inscription as inscriptionIncidents } from '../modules/incidents';
import { inscription as inscriptionPrix } from '../modules/prix';
import { inscription as inscriptionIntegrations } from '../modules/integrations';
import { inscription as inscriptionLogistique } from '../modules/logistique';

/** Routes des modules inscrits (architecture, section 13) : une ligne par module. */
const ROUTES_MODULES: readonly { chemin: string; element: ReactElement }[] = [
  ...ROUTES_STOCKS,
  ...inscriptionNotifications.routes,
  ...inscriptionMessagerie.routes,
  ...inscriptionControle.routes,
  ...inscriptionInspections.routes,
  ...inscriptionIncidents.routes,
  ...inscriptionPrix.routes,
  ...inscriptionIntegrations.routes,
  ...inscriptionLogistique.routes,
];

export function App() {
  const { etat, chargement, erreur } = useSession();
  if (chargement) {
    return (
      <div className="contenu">
        <Squelette lignes={4} libelle="Ouverture de CarburantTrack" />
      </div>
    );
  }
  if (erreur || !etat) {
    return (
      <div className="contenu">
        <MessageErreur erreur={erreur} titre="Serveur injoignable" />
      </div>
    );
  }
  if (!etat.connecte) {
    return (
      <Routes>
        <Route path="*" element={<PageConnexion />} />
      </Routes>
    );
  }
  return (
    <Coquille>
      <Routes>
        <Route path="/" element={<Accueil />} />
        <Route path="/connexion" element={<Navigate to="/" replace />} />
        <Route path="/referentiel/installations" element={<ListeInstallations />} />
        <Route path="/referentiel/installations/nouvelle" element={<NouvelleInstallation />} />
        <Route path="/referentiel/installations/:id" element={<FicheInstallation />} />
        <Route path="/referentiel/doublons" element={<Doublons />} />
        <Route path="/referentiel/organisations" element={<ListeOrganisations />} />
        <Route path="/referentiel/organisations/:id" element={<FicheOrganisation />} />
        <Route path="/referentiel/vehicules" element={<Flotte />} />
        <Route path="/catalogue" element={<Catalogue />} />
        <Route path="/documents" element={<ListeDocuments />} />
        <Route path="/documents/:id" element={<FicheDocument />} />
        <Route path="/administration/organisations" element={<AdministrationOrganisations />} />
        <Route path="/administration/utilisateurs" element={<AdministrationUtilisateurs />} />
        <Route path="/administration/utilisateurs/nouveau" element={<NouvelUtilisateur />} />
        <Route path="/administration/utilisateurs/:id" element={<FicheUtilisateur />} />
        <Route path="/administration/parametres" element={<AdministrationParametres />} />
        <Route path="/administration/roles" element={<AdministrationRoles />} />
        <Route path="/administration/journal" element={<JournalAudit />} />
        <Route path="/preferences" element={<PagePreferences />} />
        <Route path="/a-propos" element={<PageAPropos />} />
        <Route path="/recherche" element={<PageRecherche />} />
        {ROUTES_MODULES.map((r) => (
          <Route key={r.chemin} path={r.chemin} element={r.element} />
        ))}
        <Route path="*" element={<PageIntrouvable />} />
      </Routes>
    </Coquille>
  );
}

function PageIntrouvable() {
  return (
    <div>
      <h1>Page introuvable</h1>
      <p className="attenue">Cette adresse ne correspond à aucun écran disponible avec vos habilitations.</p>
    </div>
  );
}
